export default __webpack_public_path__ + "e072b7aa832b1fb683dc0d8c292717cd.mp3";